import { render, staticRenderFns } from "./elevator.vue?vue&type=template&id=00fcd2bc&scoped=true&"
import script from "./elevator.vue?vue&type=script&lang=js&"
export * from "./elevator.vue?vue&type=script&lang=js&"
import style0 from "./elevator.vue?vue&type=style&index=0&id=00fcd2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fcd2bc",
  null
  
)

export default component.exports